


























































import { Vue, Component, Prop } from "vue-property-decorator";
import { IPrice, IPriceSend } from "@/services/interfaces";
import IconPen from "@/components/icons/IconPen.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import Modal from "@/components/organisms/Modal/BaseModal/BaseModal.vue";
import PriceTypeForm from "@/components/forms/PriceTypeForm.vue";
import { pricesModule } from "@/plugins/store-accessors";
import { declension } from "@/services/utils";

@Component({
  components: { PriceTypeForm, Modal, IconTrash, IconPen },
})
export default class PriceTypes extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly prices!: IPrice[];

  showFormPriceType = false;
  showFormDelete = false;
  formId = 0;

  getRoundingText(value: number) {
    if (value) {
      return `До ${value} ${declension(value, ["рубля", "рублей", "рублей"])}`;
    }
    return "Не округлять";
  }

  openFormPriceType(id?: number) {
    this.showFormPriceType = true;
    if (id) {
      this.formId = id;
    }
  }

  openFormDelete(id: number) {
    this.showFormDelete = true;
    this.formId = id;
  }

  closeFormDelete() {
    this.showFormDelete = false;
    this.formId = 0;
  }

  closeFormPriceType() {
    this.showFormPriceType = false;
    this.formId = 0;
  }

  async sendFormPriceType(data: IPriceSend) {
    await pricesModule.sendPrice(data);
    this.showFormPriceType = false;
  }

  async deletePriceType() {
    await pricesModule.deletePrice(this.formId);
    this.showFormDelete = false;
  }
}
